import { apiBase, authHeaders } from "./auth";

function parseError(res, data) {
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return `Erro ${res.status}`;
}

async function parseJson(res) {
  try {
    return await res.json();
  } catch {
    return {};
  }
}

export async function fetchAdmClients() {
  const res = await fetch(`${apiBase()}/adm/clients`, {
    credentials: "include",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return Array.isArray(data) ? data : [];
}

export async function fetchAdmClient(idClient) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function createAdmClient(body) {
  const res = await fetch(`${apiBase()}/adm/clients`, {
    method: "POST",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function updateAdmClient(idClient, body) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function deleteAdmClient(idClient) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchAdmClientModules(idClient) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/modules`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function requestAdmModuleChange(idClient, body) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/modules/changes`, {
    method: "POST",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function confirmAdmModuleChange(idChange) {
  const res = await fetch(`${apiBase()}/adm/module-changes/${idChange}/confirm`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function rejectAdmModuleChange(idChange) {
  const res = await fetch(`${apiBase()}/adm/module-changes/${idChange}/reject`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function cancelAdmModuleChange(idChange) {
  const res = await fetch(`${apiBase()}/adm/module-changes/${idChange}/cancel`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function upsertAdmDatabase(idClient, body) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/database`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function upsertAdmDatabaseAccess(idClient, body) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/database/access`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function resetAdmDatabasePassword(idClient, body) {
  const res = await fetch(
    `${apiBase()}/adm/clients/${idClient}/database/password/reset`,
    {
      method: "POST",
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchAdmDatabasePassword(idClient) {
  const res = await fetch(
    `${apiBase()}/adm/clients/${idClient}/database/password`,
    { headers: authHeaders() }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function resetAdmAppAdminPassword(idClient) {
  const res = await fetch(
    `${apiBase()}/adm/clients/${idClient}/database/app-admin/password/reset`,
    {
      method: "POST",
      headers: authHeaders(),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function provisionAdmClient(idClient) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/provision/request`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function confirmProvisionAdmClient(idClient) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/provision/confirm`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchAdmDatabase(idClient) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/database`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchAssinatura() {
  const res = await fetch(`${apiBase()}/adm/assinatura`, {
    credentials: "include",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchSeguranca() {
  const res = await fetch(`${apiBase()}/adm/seguranca`, { headers: authHeaders() });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchConfiguracao() {
  const res = await fetch(`${apiBase()}/adm/configuracao`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function updateConfiguracao(body) {
  const res = await fetch(`${apiBase()}/adm/configuracao`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function requestPlatformDbCredentials(body) {
  const res = await fetch(
    `${apiBase()}/adm/configuracao/database-credentials/request`,
    {
      method: "POST",
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function confirmPlatformDbCredentials(body) {
  const res = await fetch(
    `${apiBase()}/adm/configuracao/database-credentials/confirm`,
    {
      method: "POST",
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function cancelPlatformDbCredentials() {
  const res = await fetch(
    `${apiBase()}/adm/configuracao/database-credentials/cancel`,
    {
      method: "POST",
      headers: authHeaders(),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchMailProviders() {
  const res = await fetch(`${apiBase()}/adm/mail-providers`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function createMailProvider(body) {
  const res = await fetch(`${apiBase()}/adm/mail-providers`, {
    method: "POST",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function updateMailProvider(id, body) {
  const res = await fetch(
    `${apiBase()}/adm/mail-providers/${encodeURIComponent(id)}`,
    {
      method: "PUT",
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function activateMailProvider(id) {
  const res = await fetch(
    `${apiBase()}/adm/mail-providers/${encodeURIComponent(id)}/activate`,
    {
      method: "POST",
      headers: authHeaders(),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function testMailProvider(id, body = {}) {
  const res = await fetch(
    `${apiBase()}/adm/mail-providers/${encodeURIComponent(id)}/test`,
    {
      method: "POST",
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function deleteMailProvider(id) {
  const res = await fetch(
    `${apiBase()}/adm/mail-providers/${encodeURIComponent(id)}`,
    {
      method: "DELETE",
      headers: authHeaders(),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

/** Singleton — repositório Google Drive da plataforma. */
export async function fetchDocStorageConfig() {
  const res = await fetch(`${apiBase()}/adm/doc-storage`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function saveDocStorageConfig(body) {
  const res = await fetch(`${apiBase()}/adm/doc-storage`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function startAdmDriveOauth() {
  const res = await fetch(`${apiBase()}/adm/doc-storage/drive/oauth/start`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function disconnectAdmDrive() {
  const res = await fetch(`${apiBase()}/adm/doc-storage/drive/disconnect`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function confirmAssinatura() {
  const res = await fetch(`${apiBase()}/adm/assinatura/confirm`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function syncPlatformAnchorEmails() {
  const res = await fetch(`${apiBase()}/adm/platform-anchors/sync-emails`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function purgeAdmProfileOrphans() {
  const res = await fetch(`${apiBase()}/adm/assinatura/purge-adm-orphans`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function updateAssinaturaOperatorEmail(body) {
  const res = await fetch(`${apiBase()}/adm/assinatura/operator-email`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function changeAssinaturaPassword(body) {
  const res = await fetch(`${apiBase()}/adm/assinatura/operator-password`, {
    method: "POST",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchSecretRotation() {
  const res = await fetch(`${apiBase()}/adm/assinatura/secret-rotation`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function requestSecretRotation(body) {
  const res = await fetch(`${apiBase()}/adm/assinatura/secret-rotation/request`, {
    method: "POST",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function confirmSecretRotation(body) {
  const res = await fetch(`${apiBase()}/adm/assinatura/secret-rotation/confirm`, {
    method: "POST",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function cancelSecretRotation() {
  const res = await fetch(`${apiBase()}/adm/assinatura/secret-rotation/cancel`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchAuthModes() {
  const res = await fetch(`${apiBase()}/adm/auth-modes`, { headers: authHeaders() });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return Array.isArray(data) ? data : [];
}

export async function fetchClientAuthPolicy(idClient) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/auth-policy`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function saveClientAuthPolicy(idClient, cdAuthMode) {
  const res = await fetch(`${apiBase()}/adm/clients/${idClient}/auth-policy`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ cd_auth_mode: cdAuthMode }),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function fetchOwnerAuthPolicy(idOwner) {
  const res = await fetch(`${apiBase()}/adm/owners/${idOwner}/auth-policy`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}

export async function saveOwnerAuthPolicy(idOwner, cdAuthMode) {
  const res = await fetch(`${apiBase()}/adm/owners/${idOwner}/auth-policy`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ cd_auth_mode: cdAuthMode }),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(parseError(res, data));
  return data;
}
